import { Button, ButtonSize } from '@atlas/components';
import classNames from 'classnames';
import { Link } from 'wouter';

import { useConfig } from 'config';
import { getMediaUrl } from 'utils/assets';
import useLayout from 'utils/layout';
import { Translation } from 'utils/translations';

import styles from './NotFound.module.scss';

const NotFound = () => {
  const layout = useLayout();
  const logoUrl = useConfig('config.siteConfig.general.logo');

  return (
    <div className={classNames(styles.wrapper, styles[layout])}>
      <img
        src={getMediaUrl('/yellow/404.webp')}
        alt="Error Page Not Found"
        className={styles.image}
      />

      <p className={styles.message}>
        <Translation message="page_not_found" />
      </p>

      <img
        src={getMediaUrl(logoUrl, 'cms')}
        alt="Project Logo"
        className={styles.logo}
      />

      <Link to="/" className={styles.button}>
        <Button size={ButtonSize.big}>
          <Translation message="go_home" />
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
